import React, { useRef } from 'react';
import { useValue } from '../../context/ContextProvider';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, TextField } from '@mui/material';
import { Close, Send } from '@mui/icons-material';
import { useAppStore } from '../../store/appStore.tsx';
import { changePassword } from '../../actions/user';

const ChangePassword = () => {
    const { state: { passwordModal }, dispatch } = useValue();
    
    // 1. EXTRAEMOS updateUser de Zustand
    const { currentUser, updateUser } = useAppStore(appStore => appStore);
    const isForced = currentUser?.mustChangePassword;

    const currentPasswordRef = useRef();
    const newPasswordRef = useRef();
    const confirmPasswordRef = useRef();

    const handleClose = (event, reason) => {
        if (isForced && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
            return;
        }
        if (!isForced) {
            dispatch({ type: 'OPEN_PASSWORD_MODAL', payload: false });
        }
    };

    // 2. CONVERTIMOS LA FUNCIÓN EN ASÍNCRONA (async)
    const handleSubmit = async (e) => { 
        e.preventDefault();
        const currentPassword = currentPasswordRef.current.value;
        const newPassword = newPasswordRef.current.value;
        const confirmPassword = confirmPasswordRef.current.value;

        if (newPassword !== confirmPassword) {
            alert('Las contraseñas nuevas no coinciden');
            return;
        }

        // 3. PONEMOS AWAIT PARA ESPERAR LA RESPUESTA
        const updatedUser = await changePassword(currentUser, { currentPassword, newPassword }, dispatch);
        
        // 4. SI TODO SALIÓ BIEN, ACTUALIZAMOS ZUSTAND Y LOCALSTORAGE
        if (updatedUser) {
            updateUser(updatedUser); 
        }

        currentPasswordRef.current.value = '';
        newPasswordRef.current.value = '';
        confirmPasswordRef.current.value = '';
    };

    return (
        <Dialog open={passwordModal?.open || false} onClose={handleClose}>
            {/* ... Todo tu JSX original se mantiene exactamente igual ... */}
            <DialogTitle>
                {isForced ? "Debe actualizar su contraseña" : "Cambiar Contraseña"}
                {!isForced && (
                    <IconButton sx={{ position: 'absolute', top: 8, right: 8, color: 'grey.500' }} onClick={handleClose}>
                        <Close />
                    </IconButton>
                )}
            </DialogTitle>
            <form onSubmit={handleSubmit}>
                <DialogContent dividers>
                    <DialogContentText>
                        Por motivos de seguridad, ingrese su contraseña actual y la nueva contraseña que desea utilizar.
                    </DialogContentText>

                    <TextField autoFocus margin='normal' variant='standard' id='currentPassword' label='Contraseña Actual' type='password' fullWidth inputRef={currentPasswordRef} required />
                    <TextField margin='normal' variant='standard' id='newPassword' label='Nueva Contraseña' type='password' fullWidth inputRef={newPasswordRef} inputProps={{ minLength: 6 }} required />
                    <TextField margin='normal' variant='standard' id='confirmPassword' label='Confirmar Nueva Contraseña' type='password' fullWidth inputRef={confirmPasswordRef} inputProps={{ minLength: 6 }} required />
                </DialogContent>
                
                <DialogActions sx={{ pr: '22px', pt: '20px', pb: '20px' }}>
                    {!isForced && (
                        <Button variant='outlined' onClick={handleClose} color="inherit">
                            Cancelar
                        </Button>
                    )}
                    <Button type='submit' variant='contained' endIcon={<Send />}>
                        Actualizar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default ChangePassword;